import script from "./EventCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./EventCard.vue?vue&type=script&setup=true&lang=ts"

import "./EventCard.vue?vue&type=style&index=0&id=06a2b754&lang=css"

const __exports__ = script;

export default __exports__